module.exports = __webpack_public_path__ + "static/media/logo2.743b6c8c.jpg";